<template>
	<div :class="['rowset']">
		<Label :for="uid" class="rowset__label" :labelText="labelText" />

		<div class="rowset__content">
			<slot name="rowset-content"></slot>
		</div>
	</div>
</template>
<script>
import Label from '@/components/forms/label/label';
export default {
	name: 'Rowset',
	components: {
		Label
	},
	props: {
		labelText: {
			type: String
		}
	}
};
</script>
<style lang="scss" scoped>
.rowset {
	width: 100%;
	display: grid;
	grid-template-columns: 1fr auto;
	column-gap: $gutter-lg;
	row-gap: $gutter-sm;
	align-items: center;

	&__label {
		font-weight: $medium-font-weight;
		margin-bottom: 0;
	}

	&__content {
		display: flex;
		align-items: center;
		grid-column: 2 / 3;
	}
}
</style>
